var map = {
	"./仲尼式-栗壳色-螺钿-金黄穗.png": 3532,
	"./仲尼式-栗壳色-螺钿-青石绿穗.png": 6667,
	"./仲尼式-栗壳色-黄金-金黄穗.png": 4044,
	"./仲尼式-栗壳色-黄金-青石绿穗.png": 715,
	"./仲尼式-黑色-螺钿-金黄穗.png": 435,
	"./仲尼式-黑色-螺钿-青石绿穗.png": 3182,
	"./仲尼式-黑色-黄金-金黄穗.png": 4319,
	"./仲尼式-黑色-黄金-青石绿穗.png": 2034,
	"./伏羲式-栗壳色-螺钿-金黄穗.png": 205,
	"./伏羲式-栗壳色-螺钿-青石绿穗.png": 7168,
	"./伏羲式-栗壳色-黄金-金黄穗.png": 1753,
	"./伏羲式-栗壳色-黄金-青石绿穗.png": 388,
	"./伏羲式-黑色-螺钿-金黄穗.png": 8552,
	"./伏羲式-黑色-螺钿-青石绿穗.png": 5663,
	"./伏羲式-黑色-黄金-金黄穗.png": 1608,
	"./伏羲式-黑色-黄金-青石绿穗.png": 2111,
	"./落霞式-栗壳色-螺钿-金黄穗.png": 9175,
	"./落霞式-栗壳色-螺钿-青石绿穗.png": 8506,
	"./落霞式-栗壳色-黄金-金黄穗.png": 3427,
	"./落霞式-栗壳色-黄金-青石绿穗.png": 6302,
	"./落霞式-黑色-螺钿-金黄穗.png": 7814,
	"./落霞式-黑色-螺钿-青石绿穗.png": 9605,
	"./落霞式-黑色-黄金-金黄穗.png": 5030,
	"./落霞式-黑色-黄金-青石绿穗.png": 2517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7356;